var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAmazon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 300 175.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient-5);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -349.66,
    y1: -113.44,
    x2: -347.55,
    y2: -113.44,
    gradientTransform: "translate(42204.48 -21311.42) rotate(-45) scale(128.69)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0c6cb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#1e84c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#4cc0ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4cc0ef"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -349.66,
    y1: -113.77,
    x2: -347.55,
    y2: -113.77,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -349.66,
    y1: -114.24,
    x2: -347.55,
    y2: -114.24,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -349.65,
    y1: -113.36,
    x2: -347.55,
    y2: -113.36,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -349.66,
    y1: -112.98,
    x2: -347.55,
    y2: -112.98,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -349.66,
    y1: -112.59,
    x2: -347.55,
    y2: -112.59,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -349.66,
    y1: -113.24,
    x2: -347.55,
    y2: -113.24,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -349.66,
    y1: -113.5,
    x2: -347.55,
    y2: -113.5,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Amazon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g923"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path844",
    className: "cls-1",
    d: "m199.4,75.83c-2.02,1.35-5.06,2.36-8.76,2.36-5.73,0-11.12-.67-16.51-2.36-1.35-.34-2.36-.67-3.03-.67-1.01,0-1.35.67-1.35,2.02v3.37c0,1.01.34,1.69.67,2.36.34.34,1.01,1.01,2.02,1.35,5.39,2.36,11.46,3.37,18.2,3.37,7.08,0,12.47-1.69,16.85-5.06,4.38-3.37,6.4-7.75,6.4-13.48,0-4.04-1.01-7.08-3.03-9.77-2.02-2.36-5.39-4.72-10.11-6.4l-9.44-3.71c-3.71-1.35-6.4-2.7-7.41-4.04-1.35-1.35-2.02-2.7-2.02-5.06,0-5.06,3.71-7.75,11.46-7.75,4.38,0,8.76.67,12.81,2.02,1.35.34,2.36.67,2.7.67,1.01,0,1.69-.67,1.69-2.02v-3.37c0-1.01-.34-1.69-.67-2.36-.34-.67-1.01-1.01-2.02-1.35-5.06-1.69-10.11-2.7-15.17-2.7-6.4,0-11.8,1.69-15.84,4.72s-6.07,7.41-6.07,12.47c0,7.75,4.38,13.48,13.14,16.85l10.11,3.71c3.37,1.35,5.39,2.36,6.74,3.71,1.35,1.35,1.69,2.7,1.69,4.72,0,2.7-1.01,5.06-3.03,6.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path855",
    className: "cls-5",
    d: "m146.49,27.3v44.82c-5.73,3.71-11.46,5.73-17.19,5.73-3.71,0-6.4-1.01-8.09-3.03s-2.36-5.06-2.36-9.44V27.3c0-1.69-.67-2.36-2.36-2.36h-7.08c-1.69,0-2.36.67-2.36,2.36v41.79c0,5.73,1.35,10.45,4.38,13.48,3.03,3.03,7.41,4.72,13.14,4.72,7.75,0,15.5-2.7,22.92-8.09l.67,4.04c0,1.01.34,1.35,1.01,1.69.34.34,1.01.34,2.02.34h5.06c1.69,0,2.36-.67,2.36-2.36V27.3c0-1.69-.67-2.36-2.36-2.36h-7.08c-2.02,0-2.7,1.01-2.7,2.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path866",
    className: "cls-3",
    d: "m82.45,85.6h7.08c1.69,0,2.36-.67,2.36-2.36v-42.13c0-5.73-1.35-10.11-4.38-13.14-3.03-3.03-7.08-4.72-12.81-4.72-7.75,0-15.84,2.7-23.59,8.43-2.7-5.73-7.75-8.43-15.17-8.43s-14.83,2.7-22.24,7.75l-.67-3.71c0-1.01-.34-1.35-1.01-1.69-.34-.34-1.01-.34-1.69-.34h-5.39c-1.69,0-2.36.67-2.36,2.36v55.95c0,1.69.67,2.36,2.36,2.36h7.08c1.69,0,2.36-.67,2.36-2.36v-45.5c5.73-3.37,11.46-5.39,17.52-5.39,3.37,0,5.73,1.01,7.08,3.03,1.35,2.02,2.36,4.72,2.36,8.76v38.76c0,1.69.67,2.36,2.36,2.36h7.08c1.69,0,2.36-.67,2.36-2.36v-45.16c6.07-3.71,11.8-5.39,17.52-5.39,3.37,0,5.73,1.01,7.08,3.03s2.36,4.72,2.36,8.76v38.76c0,1.69.67,2.36,2.36,2.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path877",
    className: "cls-4",
    d: "m266.13,130.43c-36.73,15.5-76.84,23.25-113.24,23.25-53.92,0-106.16-14.83-148.29-39.43-.67-.34-1.35-.67-2.02-.67-2.36,0-3.71,2.7-1.35,5.06,39.09,35.39,90.99,56.62,148.29,56.62,41.12,0,88.64-12.81,121.33-37.07,5.73-4.04,1.01-10.11-4.72-7.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path888",
    className: "cls-8",
    d: "m265.12,38.42c3.03-3.37,7.75-5.06,14.49-5.06,3.37,0,6.74.34,9.77,1.35,1.01.34,1.35.34,2.02.34,1.01,0,1.69-.67,1.69-2.36v-3.37c0-1.01-.34-2.02-.67-2.36-.34-.34-1.01-1.01-1.69-1.35-4.38-1.01-8.76-2.02-12.81-2.02-9.44,0-16.51,2.7-21.91,8.43-5.06,5.39-7.75,13.48-7.75,23.59s2.36,17.86,7.41,23.25c5.06,5.39,12.13,8.09,21.57,8.09,5.06,0,9.77-.67,13.48-2.36,1.01-.34,1.69-.67,2.02-1.35.34-.34.34-1.35.34-2.36v-3.37c0-1.69-.67-2.36-1.69-2.36-.34,0-1.01,0-1.69.34-3.71,1.01-7.41,1.69-10.78,1.69-6.4,0-11.12-1.69-14.15-5.06-3.03-3.37-4.38-8.76-4.38-15.84v-1.69c.34-7.41,1.69-12.81,4.72-16.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path899",
    className: "cls-6",
    d: "m280.28,162.11c17.52-14.83,22.24-45.5,18.54-50.22-1.69-2.02-9.77-4.04-19.88-4.04-10.78,0-23.59,2.36-33.36,9.1-3.03,2.02-2.36,4.72.67,4.38,10.45-1.35,34.04-4.04,38.42,1.35,4.04,5.39-4.72,27.64-8.76,37.41-1.01,3.03,1.35,4.04,4.38,2.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path910",
    className: "cls-7",
    d: "m233.44,24.94h-7.08c-1.69,0-2.36.67-2.36,2.36v55.95c0,1.69.67,2.36,2.36,2.36h7.08c1.69,0,2.36-.67,2.36-2.36V27.3c0-1.35-.67-2.36-2.36-2.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path921",
    className: "cls-2",
    d: "m235.46,2.02c-1.35-1.35-3.37-2.02-5.73-2.02s-4.04.67-5.39,2.02-2.02,3.03-2.02,5.06.67,4.04,2.02,5.06c1.35,1.35,3.03,2.02,5.39,2.02s4.04-.67,5.39-2.02,2.02-3.03,2.02-5.06-.34-4.04-1.69-5.06Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmazon);
export default __webpack_public_path__ + "static/media/Amazon.c74a3ee4bf9ac15ce228092d6b051e10.svg";
export { ForwardRef as ReactComponent };